import { useObservable } from "@rsm";
import { LoadingPage } from "components/LoadingPage/LoadingPage";
import { useHasFF } from "hooks/useHasFF";
import { useMainNavigate } from "hooks/useMainNavigate";
import { useResultsModuleBLoC } from "modules/ResultsModule/ResultsModule.bloc";
import { ResultsModuleHelpers } from "modules/ResultsModule/ResultsModule.helpers";
import React, { useEffect } from "react";

export const ResultsLandingPage: React.FC<{}> = () => {
  const { project$, followUpQuestions$ } = useResultsModuleBLoC();
  const project = useObservable(project$);
  const followUpQuestions = useObservable(followUpQuestions$);
  const hasLaunchTestRevampFf = useHasFF("LaunchTestRevamp");
  const navigate = useMainNavigate();

  useEffect(() => {
    if (!project) return;
    const navigateToResults = (route: string) => {
      void navigate(ResultsModuleHelpers.internalResultsLink(project.id, route), { replace: true });
    };

    const route = ResultsModuleHelpers.getChartsRoute(
      project.projectType,
      project.frameworkId,
      followUpQuestions?.[0]
        ? { id: followUpQuestions[0].id, questionTypeId: followUpQuestions[0].question.questionTypeId }
        : null,
      !!hasLaunchTestRevampFf,
    );
    if (route) navigateToResults(route);
  }, [project, navigate, followUpQuestions, hasLaunchTestRevampFf]);

  return <LoadingPage />;
};
